import axios from 'axios';

// Analisi prezzi dei siti concorrenti (backend: /api/v1/competitor).
// Tutte le azioni ritornano il body della risposta oppure { error }.

const richiesta = async (context, method, url, data, params) => {
	return await axios({
		method,
		url: `${context.rootGetters['settings/getUrl']}competitor/${url}`,
		data,
		params,
		headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}`, 'Content-Type': 'application/json' },
	})
		.then(res => res.data)
		.catch(err => ({ error: err.response ? err.response.data : err.message }));
};

const actions = {
	// { sites: [...], max }
	fetchSites: context => richiesta(context, 'get', 'sites'),
	createSite: (context, payload) => richiesta(context, 'post', 'sites', payload),
	updateSite: (context, { id, payload }) => richiesta(context, 'put', `sites/${id}`, payload),
	deleteSite: (context, id) => richiesta(context, 'delete', `sites/${id}`),

	// Regole di estrazione del sito (stesso sistema di Import da marchi)
	// { rules: [versioni senza fields/preview] }
	fetchSiteRules: (context, siteId) => richiesta(context, 'get', `sites/${siteId}/rules`),
	// { rule }
	fetchRules: (context, rulesId) => richiesta(context, 'get', `rules/${rulesId}`),
	// crawl undefined = non inviato (il backend lascia la navigazione com'è); null = rimuove
	updateRules: (context, { rulesId, fields, crawl }) => richiesta(context, 'put', `rules/${rulesId}`, crawl === undefined ? { fields } : { fields, crawl }),
	createRules: (context, { siteId, fields, sampleUrls }) => richiesta(context, 'post', 'rules', { siteId, fields, ...(sampleUrls ? { sampleUrls } : {}) }),
	activateRules: (context, rulesId) => richiesta(context, 'post', `rules/${rulesId}/activate`),
	// { snapshot: { url, html } }
	fetchSnapshot: (context, snapshotId) => richiesta(context, 'get', `snapshots/${snapshotId}`),

	// type: scan | match | generate_rules | preview_rules (rulesId) | snapshot (url); sampleUrls opzionale
	createJob: (context, { siteId, type, rulesId, sampleUrls, url }) => {
		const payload = { siteId, type };
		if (rulesId) payload.rulesId = rulesId;
		if (sampleUrls) payload.sampleUrls = sampleUrls;
		if (url) payload.url = url;
		return richiesta(context, 'post', 'jobs', payload);
	},
	fetchJobs: (context, params) => richiesta(context, 'get', 'jobs', null, params),
	fetchJob: (context, jobId) => richiesta(context, 'get', `jobs/${jobId}`),
	cancelJob: (context, jobId) => richiesta(context, 'post', `jobs/${jobId}/cancel`),

	// params: { siteId, q, matched, page, limit }
	fetchProducts: (context, params) => richiesta(context, 'get', 'products', null, params),
	// itemId null = rimuove l'abbinamento
	// un prodotto concorrente (pagina Abbinamento)
	fetchProduct: (context, id) => richiesta(context, 'get', `products/${id}`),
	setMatch: (context, { id, itemId, variantSku }) => richiesta(context, 'put', `products/${id}/match`, { itemId, variantSku }),
	searchItems: (context, q) => richiesta(context, 'get', 'items/search', null, { q }),

	// params: { q, status: all|beaten|winning, page, limit }
	fetchAnalysis: (context, params) => richiesta(context, 'get', 'analysis', null, params),
	applyPrice: (context, { itemId, variantSku, price }) => richiesta(context, 'post', 'analysis/apply-price', { itemId, variantSku, price }),
};

export default {
	namespaced: true,
	state: {},
	mutations: {},
	getters: {},
	actions,
};
